import { useStableCallback } from '@joyful/utils'
import { useRegisterGlobalCommands } from '../../../components/global-command/GlobalCommandCore'

export function useRegisterLeaveFeedbackCommand({
  onLeaveFeedback,
}: {
  onLeaveFeedback: () => void
}) {
  const onLeaveFeedbackStable = useStableCallback(onLeaveFeedback)

  useRegisterGlobalCommands(() => {
    return [
      {
        description: 'Send product feedback with an optional screenshot',
        key: 'leave-feedback',
        onSelect: () => {
          onLeaveFeedbackStable()
        },
        startAdornment: '✉️',
        title: 'Leave feedback',
      },
    ]
  }, [])
}
